import './HeaderFunnel.css'
import Logo from "../../../images/logo-dark.svg";
import mobileLogo from "../../../images/logo-symbol.svg";
import chevronLeft from "../../../icons/Chevron-Left.png";
import * as translator from "../../../utils/translator";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { clientConfig } from "../../../config";
import StepsListV2 from '../../StepsListV2';
import CannabisProgressBar from '../../CannabisProgressBar';
import LanguageToggle from '../HeaderCMS/LanguageToggle';

export default function HeaderFunnel({stage, country, language, showSteps=true, flow, showBackButton=true, headerVersion, carePlusSteps=false}) {

  const locale = `${language.toLowerCase()}-${country.toUpperCase()}`
  const countryPath = translator.getCMSUrlPrefixByLocale(locale)
  const navigate = useNavigate()
  const [isMobile,setIsMobile] = useState(window.innerWidth < 767);
  
  const handleScreenResize = () => {
   if (window.innerWidth < 767){
    setIsMobile(true)
   } else {
    setIsMobile(false)
   }
  }

  useEffect(() => {
    window.addEventListener("resize", handleScreenResize)
  })

  return (
    <>
    
     {/* Hide header for cannabis funnel only */}
     {headerVersion !== 'v2' && (
       <div className={`header-container ${stage === 'StartConsultation' ? 'header-container-start-consultation' : ''} ${isMobile && "relative"}`}>
          <div className='header-links'>
                 {
                  showBackButton && (stage==="Questionnaire" || stage === "Payment" || stage === "RegistrationPage" || stage === "StartConsultation") ?
                  <div className='header-return-container'>
                    <img onClick={() => navigate(-1)} style={isMobile? {width:22, height:22,} : null} src={chevronLeft}/>
                    {
                      isMobile ? 
                      null 
                      :
                      <a onClick={() => navigate(-1)} className='header-return-text'>{translator.translate(language, "default", "HeaderQuestionnaire/return")}</a>
                    }
                  </div>
                  :
                  <span></span>
                }
                  
                  <img className={isMobile ? 'header-mobileLogo' : 'header-logo' } src={isMobile ? mobileLogo : Logo} alt="logo" onClick={() => window.location = (`${clientConfig.MAIN_WEBSITE_URL}/${countryPath}`)}/>
          </div>
          {/* Language Toggle */}
          <LanguageToggle country={country} language={language} />
      </div>
     )}

    {
      showSteps &&
      (headerVersion === 'v2' ? (
        <CannabisProgressBar stage={stage} language={language} country={country} isMobile={isMobile} flow={flow}/>
      ) : (
        <StepsListV2 stage={stage} language={language} isMobile={isMobile} flow={flow} carePlusSteps={carePlusSteps}/>
      ))
    }
              
    </>
  )
}
